// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper_1FmzO","icons":"style_icons_1-ZC2","subscriptionCheck":"style_subscriptionCheck_SliLx","title":"style_title_1VLok"};